(() => {
  if (window.LelloCartSync?.isCleanCartBridge) return;

  const shopRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  let timer;
  let refreshing = false;
  let refreshRequested = false;
  let openRequested = false;
  let returnFocus;
  let pending;
  let resolvePending;
  let lastCompletedAt = 0;

  async function cartState() {
    try {
      const response = await fetch(`${shopRoot}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      return response.ok ? await response.json() : null;
    } catch {
      return null;
    }
  }

  async function flush() {
    clearTimeout(timer);
    if (refreshing || !pending) return;
    refreshing = true;
    refreshRequested = false;
    let cart = null;
    let refreshFailed = false;
    try {
      await window.LelloCleanCart?.refresh();
      cart = await cartState();
    } catch {
      refreshFailed = true;
    }
    refreshing = false;

    if (refreshRequested) {
      timer = setTimeout(flush, 100);
      return;
    }

    const complete = resolvePending;
    const shouldOpen = openRequested;
    const trigger = returnFocus;
    pending = null;
    resolvePending = null;
    openRequested = false;
    returnFocus = null;
    lastCompletedAt = Date.now();

    if (shouldOpen) window.LelloCleanCart?.open(trigger, refreshFailed);
    document.dispatchEvent(new CustomEvent('lello:cart-changed', {
      detail: { synced: true, cart }
    }));
    complete(cart);
  }

  function refresh(options = {}) {
    refreshRequested = true;
    openRequested ||= !!options.open;
    if (!pending) {
      returnFocus = document.activeElement;
      pending = new Promise((resolve) => { resolvePending = resolve; });
    }
    clearTimeout(timer);
    timer = setTimeout(flush, 100);
    return pending;
  }

  window.LelloCartSync = { refresh, isCleanCartBridge: true };

  document.addEventListener('cart:refresh', () => refresh({ open: true }));
  document.addEventListener('lello:cart-changed', (event) => {
    if (!event.detail?.synced) refresh({ open: true });
  });

  window.addEventListener('click', (event) => {
    if (event.isTrusted || !window.LelloCleanCart) return;
    const opener = event.target.closest?.('#cart-drawer-opener[data-drawer-to-open="cart-drawer"]');
    if (!opener) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) {
      openRequested = true;
      return;
    }
    if (Date.now() - lastCompletedAt < 1000) return;
    refresh({ open: true });
  }, true);
})();
